export default {
    authenticated: false,
    admin: false,
    isSuper: false,
    isBroker: false,
    broker: {},
    userId: null,
    companies: [],
    refreshToken: null,
    ffinuser: null,
    ffincompany: null,
    expires: 0,
    ignoringEsignThisSession: false,
    bfiUserAddModal: {
        isOpen: false,
    },
    featureList: [],
};
